/*
export const colors = [
  {code: "#FF9999", name: "赤"},
  {code: "#00FF00", name: "緑"},
  {code: "#4169E1", name: "青"},
  {code: "#FFFF00", name: "黄"},
  {code: "#FF99FF", name: "マゼンタ"},
  {code: "#00FFFF", name: "水色"},
  {code: "#FFB6C1", name: "薄い赤"},
  {code: "#98FB98", name: "薄い緑"},
  {code: "#ADD8E6", name: "薄い青"},
  {code: "#FFFFE0", name: "薄い黄"},
  {code: "#E6E6FA", name: "薄い紫"},
  {code: "#E0FFFF", name: "薄い水色"},
  {code: "#D3D3D3", name: "薄いグレー"},
  {code: "#FFC0CB", name: "ピンク"},
  {code: "#32CD32", name: "ライム"},
  {code: "#9999FF", name: "青紫"},
  {code: "#FF8C00", name: "オレンジ"},
  {code: "#DDA0DD", name: "梅色"},
  {code: "#DEB887", name: "ベージュ"},
  {code: "#20B2AA", name: "青緑"},
];
*/

export const colors = [
  /* Gray */
  {code: "#f8f9fa" },
  {code: "#dee2e5" },
  {code: "#cfd4d9" },
  {code: "#afb5bc" },
  {code: "#6e757c" },

  /* Brown */
  {code: "#f4f0e7" },
  {code: "#e4ddce" },
  {code: "#d2c2b5" },
  {code: "#bda485" },
  {code: "#a07d58" },

  /* Orange */
  {code: "#fdf1e1" },
  {code: "#f9d9b7" },
  {code: "#f6c59f" },
  {code: "#f3b187" },
  {code: "#f19d6f" },

  /* Yellow */
  {code: "#fffde3" },
  {code: "#fffbbb" },
  {code: "#fffaa5" },
  {code: "#fff87d" },
  {code: "#fff86d" },

  /* Red */
  {code: "#fbe6e5" },
  {code: "#f3b6b5" },
  {code: "#f19e9c" },
  {code: "#ef8683" },
  {code: "#ed706b" },

  /* Purple */
  {code: "#f2e1fd" },
  {code: "#d9b5fa" },
  {code: "#c59bf9" },
  {code: "#ac82f7" },
  {code: "#9268c6" },

  /* Purple-Blue */
  {code: "#e6e6fd" },
  {code: "#ccccfb" },
  {code: "#b3b3f9" },
  {code: "#9999f8" },
  {code: "#8080f7" },

  /* Blue */
  {code: "#e3effd" },
  {code: "#bad8fb" },
  {code: "#a4cbfb" },
  {code: "#8db9f9" },
  {code: "#76a8f9" },

  /* Teal */
  {code: "#e6fef6" },
  {code: "#c4fdef" },
  {code: "#b1fcee" },
  {code: "#a1fcdf" },
  {code: "#80cabc" },

  /* Green */
  {code: "#eafee8" },
  {code: "#d6fcd0" },
  {code: "#b1faa3" },
  {code: "#92f97a" },
  {code: "#67c94d" },
];